import requestHelper from '../../plugins/requestHelper';
import {findClosestElementByClass} from '../helpers/dom/closest';
import errors from '../../plugins/errors';

Vue.component('diagnostic-form', {
	delimiters: ['{[{', '}]}'],
	data: function () {
		return {
			results: {},
			filled: false,
			disabledButton: true,
			validForm: true,
			isError: false
		};
	},
	mounted () {
		this.fetchData();
	},
	updated () {
		// console.log($('[data-mask]'), $('input[type=text]'), this.$el.querySelector('[data-mask]'), this.$el.querySelector('input[type=text]'));
		// $('[data-mask]').mask($('[data-mask]').attr('data-mask'));
	},
	template: '#diagnostic-form',
	methods: {
		focusInput: function (event) {
			event.target.parentNode.classList.add('focus');
		},
		blurInput: function (event) {
			event.target.parentNode.classList.remove('focus');
		},
		filledInput: function (event) {
			// console.log('event.target.value.length', event.target.value.length, event.target.value);
			if (event.target.value.length > 0) {
				event.target.parentNode.classList.add('filled');
			} else {
				event.target.parentNode.classList.remove('filled');
			}			
		},
		fetchData: function () {

			diagnosticsApp = document.querySelector('#diagnostics');
			const errorField = diagnosticsApp.querySelector('[data-error-field]');
            this.$root.showLoader = true;
			requestHelper
				.request(diagnosticsApp.getAttribute('method'), diagnosticsApp.getAttribute('data-from'))
				.then(res => {
					this.results = JSON.parse(res);
					// console.log(this.results);
                    this.$root.showLoader = false;
				})
				.catch(e => {
					console.log(e);
					this.isError = true;
					errors.showError(e.status, errorField);
                    this.$root.showLoader = false;
				});
		},
		onSubmit: function () {

			this.isError = false;
			
// FIXME: enter submituje pusty form

			diagnosticsApp = document.querySelector('#diagnostics');
			const form = diagnosticsApp.querySelector('form');
			// const formdata = new FormData(form);
			const formdataObj = $('#diagnostics form').serializeArray();
			// console.log(diagnosticsApp, form, formdataObj);

			const formObject = {};
			// [].forEach.call(formdataObj, (value, key) => {
			// 	formObject[key] = value;
			// });
			// formdataObj.forEach(function(value, key){
			// formObject[key] = value;
			// // console.log(key, '-', value);
			// });

			for (var i = 0; i < formdataObj.length; i++){
				formObject[formdataObj[i]['name']] = formdataObj[i]['value'];
			  }
			const formdata = encodeURIComponent(JSON.stringify(formObject));
			// console.log("formdata", formdata);
			// console.log("formdata", encodeURIComponent(formdata));
			// console.log("formdata", decodeURIComponent(encodeURIComponent(formdata)));
			// console.log("formdata", window.atob(window.btoa(formdata)));

// TODO: wydzielic jako funkcje/export

			const textInputs = form.querySelectorAll('input[type=text], textarea');
			this.validForm = true;
			for (let i = 0; i < textInputs.length; i++) {
				if (textInputs[i].value !== '') {
					let reString = textInputs[i].getAttribute('data-validation-exp');
					if (reString) {
						let re = new RegExp(reString);
						// console.log(textInputs[i].getAttribute('data-validation-exp'), typeof(textInputs[i].getAttribute('data-validation-exp')), new RegExp(re), typeof(new RegExp(re)));
						if (re.test(textInputs[i].value)) {
							textInputs[i].parentNode.classList.remove('error');
						} else {
							textInputs[i].parentNode.classList.add('error');
							this.validForm = false;
						}
					}
				} else {
					textInputs[i].parentNode.classList.remove('error');
				}
			}
			// console.log(diagnosticsApp.querySelectorAll('input[type=text]'));




			if (this.validForm) {
				this.submitForm(formdata);
			}
		},
		cancelSubmit: function () {
			this.submitForm(JSON.stringify({
				'id': this.results.id,
				'diagnostic_id': this.results.diagnostic_id,
				'csrf_token': this.results.csrf_token,
				'skip': 1
			}));
		},
		submitForm: function (dataToSend) {
			// console.log(dataToSend, typeof(dataToSend));

			diagnosticsApp = document.querySelector('#diagnostics');
			const errorField = diagnosticsApp.querySelector('[data-error-field]');

            this.$root.showLoader = true;
			requestHelper
				.request(diagnosticsApp.getAttribute('method'), diagnosticsApp.getAttribute('data-url'), dataToSend, 'application/x-www-form-urlencoded')
				.then(res => {
					res = JSON.parse(res);
					if (res.success === true) {
						document.querySelector('.banner-main__title').innerHTML = res['thank-you-page']['banner-main__title'];
						document.querySelector('.banner-main__description').innerHTML = res['thank-you-page']['banner-main__description'];
						if (document.querySelector('.banner-main__description--semibold')) {
							document.querySelector('.banner-main__description--semibold').innerHTML = res['thank-you-page']['banner-main__description--semibold'];
						}						
						// diagnosticsApp = document.querySelector('#diagnostics');
						const formPlaceholder = findClosestElementByClass(diagnosticsApp, 'placeholder');
						// console.log(diagnosticsApp, formPlaceholder);
						formPlaceholder.style.display = 'none';
						document.querySelector('.' + res['thank-you-page'].id).style.display = 'block';
						window.scrollTo(0, 0);
					}else{
						this.isError = true;
						errors.showError(res.ErrorCode, errorField);
					}
                    this.$root.showLoader = false;
				})
				.catch(e => {
					console.log(e);
					this.isError = true;
					errors.showError(e.status, errorField);
                    this.$root.showLoader = false;
				});
		},
		showCommentAndTextarea: function (answer, result) {
			// console.log(answer.textarea);
			this.filled = true;
			this.disabledButton = false;
			if (result.type === 'checkbox') {
				if (answer.textarea) {
					answer.textarea.visible = !answer.textarea.visible;
				}
				if (answer.comment) {
					answer.comment.visible = !answer.comment.visible;
				}
			} else if (result.type === 'radio') {
				for (let i = 0; i < result.answers.length; i++) {
					if (result.answers[i].textarea) {
						result.answers[i].textarea.visible = false;
					}
					if (result.answers[i].comment) {
						result.answers[i].comment.visible = false;
					}
				}
				if (answer.textarea) {
					answer.textarea.visible = true;
				}
				if (answer.comment) {
					answer.comment.visible = true;
				}
			}
		}

	}
});

var diagnosticsApp = document.querySelector('#diagnostics');
// if (diagnosticsApp) {
// 	var app = new Vue({
// 		el: '#diagnostics',
// 		delimiters: ['{[{', '}]}'],
// 		methods: {

// 		}
// 	});
// }
